import styled from 'styled-components';

import { InputWrapV2 } from '../InputV2/InputV2Styles';
import theme from '../../../styles-and-themes/themes/theme';

export const AutosuggestWrap = styled(InputWrapV2)`
  position: relative;
  width: ${(p) => p.width};
  max-width: ${(p) => p.width};
  .loader {
    position: absolute;
    right: 10px;
    top: 6px;
    > div {
      margin: 0;
    }
  }
  ul {
    text-align: left;
    cursor: default;
    border: 1px solid ${theme.medium_gray};
    border-top: 0;
    background: ${theme.white};
    box-shadow: -1px 1px 3px rgba(0,0,0,.1);
    position: absolute;
    z-index: 9999;
    max-height: 350px;
    width: ${(p) => p.width};
    min-width: ${(p) => p.width};
    overflow: hidden;
    overflow-y: auto;
    box-sizing: border-box;
    max-width: 420px;
    width: 100%;
    display: block;
    list-style-type: none;
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 0;
  }
  .schoolItem {
    min-width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .cityState {
      color: ${theme.dark_gray};
      font-size: 10px;
    }
  }
  li {
    position: relative;
    padding: 0 .6em;
    line-height: 23px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 1.02em;
    color: ${theme.charcoal};
    &:hover {
      background-color: rgb(3, 0, 165);
      color: white;
    }
  }
  // Highlight the currently focused item in the autosuggest dropdown (like we do with :hover)
  li.react-autosuggest__suggestion--highlighted {
    background-color: rgb(3, 0, 165);
    color: white;
  }
  li b {
    font-weight: normal;
    color: #1f8dd6;
  }
  li.selected { background: ${theme.off_white}; }
  .cAccount {
    display: none;
  }
  input {
    border: 1px solid ${(p) => (p.hasError ? theme.Macmillan_red : theme.dark_grey)} !important;
    background: ${(p) => (p.hasError ? theme.very_light_red : theme.white)} !important;
  }
  input:disabled,
  input[readonly] {
    background: ${theme.very_light_gray} !important;
    color: ${theme.very_dark_gray} !important;
    border-color: transparent !important;
  }
`;
